import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
// import huawei from "../components/huawei.vue";
// import vivo from "../components/vivo.vue";
// import meizu from "../components/meizu.vue";
// import other from "../components/other.vue";
// import xiaomi from "../components/xiaomi.vue";
// import wzrytxy from "../components/wzrytxy.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  //   {
  //     path: "/about",
  //     name: "About",
  //     // route level code-splitting
  //     // this generates a separate chunk (about.[hash].js) for this route
  //     // which is lazy-loaded when the route is visited.
  //     component: () =>
  //       import(/* webpackChunkName: "about" */ "../views/About.vue"),
  //   },
  //   {
  //     path: "/huawei",
  //     name: "huawei",
  //     component: huawei,
  //   },
  //   {
  //     path: "/vivo",
  //     name: "vivo",
  //     component: vivo,
  //   },
  //   {
  //     path: "/meizu",
  //     name: "meizu",
  //     component: meizu,
  //   },
  //   {
  //     path: "/other",
  //     name: "other",
  //     component: other,
  //   },
  //   {
  //     path: "/xiaomi",
  //     name: "xiaomi",
  //     component: xiaomi,
  //   },
  //   {
  //     path: "/wzrytxy",
  //     name: "wzrytxy",
  //     component: wzrytxy,
  //   },
];

const router = new VueRouter({
  // mode: 'history',
  base: "process.env.BASE_URL",
  routes,
});

export default router;
